import axios from 'axios'
import { Message } from 'element-ui'
import Router from '@/router'
import Store from '@/store/index.js'
import i18n from '@/lang'
import Tool from '@/assets/js/utils.js'
const nodeurl = require('url')
// 特殊处理erroInfo
const Msg = {
  82201303: {
    message: 'Modification failed, it can not be modified until the output stream is stopped.',
    type: 'warning'
  }
}

// http request 拦截器

// 设置默认超时时间为30s， timeoutTips设置为true，会有请求超时的提示，默认不提示
axios.defaults.withCredentials = true
axios.defaults.timeout = 60000

// 用于连续多次点击时，取消之前的请求，之保留最后一次的请求状态
const pending = [] // 声明一个数组用于存储每个正在pending的状态请求
const CancelToken = axios.CancelToken
const removePending = (config, str) => {
  for (const i in pending) {
    if (pending[i].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      pending[i].f() // 执行取消操作
      pending.splice(i, 1)
    }
  }
}


axios.interceptors.request.use(config => {
  if (config.isCancelToken) {
    removePending(config, 'request') // 在一个axios发送前执行一下取消操作
    config.cancelToken = new CancelToken(() => {
      // 这里的axios标识用请求地址&请求方式拼接的字符串
      pending.push({ u: config.url + '&' + config.method })
    })
  }
  if (config.url.indexOf('api.agora.io') >= 0) {
    config.headers.Authorization = config.token
  }

  config.headers['Content-Type'] = 'application/json'

  // 统一处理join接口，partyCode/groupId需要全部是数字
  if (config.url.indexOf('/join') > -1) {
    if (config.data) {
      const data = config.data
      if (data.groupId && typeof config.data === 'string') data.groupId = data.groupId.replace(/[^0-9]/ig, '')
      if (data.partyCode && typeof config.partyCode === 'string') data.partyCode = data.partyCode.replace(/[^0-9]/ig, '')
      config.data = data
    }
  }

  if (config.requestBase && config.requestBase === 'GATEWAY') {
    const protocol = window.location.protocol
    const url = `${protocol}//${Store.state.config.urlInfo['gateway.url']}/drive`
    config.baseURL = url
  }
  return config
}, err => {
  return Promise.reject(err)
})

axios.interceptors.response.use(
  response => {
    if (response.config && response.config.isCancelToken) {
      removePending(response.config, 'response') // 在一个axios响应后再执行一下取消操作，把已经完成的请求从pending中移除
    }
    if (response.data.errorCode !== '0x0') {
      if (response.data.errorInfo && response.config.errorTip !== false) {
        if (response.data.errorCode === '82200106') {
          Message({
            message: 'Receiver is already live with another source.',
            type: 'error',
            offset: 50,
            showClose: true
          })
        } else if (response.data.errorCode === '82201002') {
          Message({
            message: 'The current receiver version is older, if you want to ues this feature please update your receiver.',
            type: 'error',
            offset: 50,
            showClose: true
          })
        } else if (response.data.errorCode === '82200301') {
          Message({
            message: 'Please check the Receiver.',
            type: 'error',
            offset: 50,
            showClose: true
          })
        } else if (response.data.errorCode === '82200302') {
          Message({
            message: 'Please try again.',
            type: 'error',
            offset: 50,
            showClose: true
          })
        } else if (response.data.errorCode === '82200304') {
          Message({
            message: '<div>The current network connection is faulty. Please check the following:<ul><li>- R port need to be correct.</li><li>- Network need to be stable.</li><li>- The pairing/connection between TVU Anywhere and Receiver failed, please try again.</li></ul></div>',
            type: 'error',
            offset: 50,
            dangerouslyUseHTMLString: true,
            showClose: true
          })
        } else if (response.data.errorCode === '9000003') {
          Message({
            message: i18n.t('responeInfo.maximumParty') + response.data.errorResult.maximumCreationNumber + '.',
            type: 'error',
            offset: 50,
            showClose: true
          })
        } else if (response.data.errorCode === '82201104') {
          Message({
            type: 'warning',
            message: i18n.t('common.maxNumber'),
            offset: 50,
            showClose: true
          })
        } else if (response.data.errorCode === '81000013' || response.data.errorCode === '82201504') {
          Router.push({ name: 'remove', query: { type: 'disableParty' } })
        } else if (response.data.errorCode === '81000002' || response.data.errorCode === '0x80060005') {
          // 直接返回response即可，不弹出任何信息
          return response;
        } else if (response.data.errorCode === '81000004') {
          Message({
            message: response.data.errorInfo,
            type: 'error',
            offset: 50,
            showClose: true
          })
        } else {
          if (document.getElementsByClassName('el-message').length === 0) {
            Message({
              message: (Msg[response.data.errorCode] && Msg[response.data.errorCode].message) || response.data.errorInfo,
              type: (Msg[response.data.errorCode] && Msg[response.data.errorCode].type) || 'error',
              offset: 50,
              showClose: true
            })
          }
        }
      }
    }
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 503:
        case 500:
        case 502:
          Message({
            message: i18n.t('responeInfo.tryAgain', { errorCode: error.response.status }),
            type: 'error',
            offset: 50,
            showClose: true
          })
          break
        case 406:
        case 402:
        case 401:
          if ((error.response.status === 401 || error.response.status === 402) && error.response.config.url.includes('getServiceVersion')) return
          let partyCode = ''
          const URL = nodeurl.parse(location.href, true)
          if (URL.query.join_id || URL.query.id) {
            partyCode = URL.query.join_id || URL.query.id
          }
          if (partyCode) {
            Tool.removeHostLoginInfo()
            Router.push({
              name: 'preview',
              query: {
                id: partyCode,
                notNeedLoginInfo: true
              }
            })
          } else {
            Store.commit('jumpLoginPage')
          }
          break
        // 超时
        case 400:
        case 403:
          Message({
            message: error.response.data.errorInfo,
            type: 'error',
            offset: 50,
            showClose: true
          })
          break
        case 504:
          Message({
            message: 'Timeout',
            type: 'error',
            offset: 50,
            showClose: true
          })
          break
      }
      return Promise.reject(error)
    }
    if (Store.state.networkConnect) {
      if (error.message?.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
        Message({
          message: 'Request timed out, please check the network first',
          type: 'error',
          offset: 50,
          showClose: true,
          single: true
        })
        return {
          data: {
            errorCode: '82200304',
            errorInfo: 'Timeout',
            result: {}
          }
        }
      }
    }
    if (
      !error.response ||
      !error.message ||
      error.message === 'Network Error' ||
      (error.message && error.message.includes('cancelled'))
    ) {
      const error = new Error('Request canceled')
      error.data = {
        errorCode: '8220000',
        errorInfo: 'Cancel',
        result: {}
      }
      return Promise.reject(error)
    }
  })
export default axios
